// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ye_v","colMin":"styles_colMin__CKdIG"};